import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/menu-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-033d30df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex sm:justify-center bg-black" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex sm:block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-full w-32 sm:h-60 sm:w-64 m-0 pl-3 sm:pl-0 pt-3 sm:pt-5",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "block sm:hidden text-white text-center font-russo text-2xl sm:text-3xl px-5 sm:px-0 pt-6 sm:pt-0" }
const _hoisted_4 = { class: "hidden sm:block flex bg-black" }
const _hoisted_5 = { class: "text-white text-center font-russo text-2xl sm:text-4xl px-5 sm:px-0 pt-6 sm:pt-0 pb-2" }
const _hoisted_6 = { class: "pt-8 pb-2 text-red-600 text-medium sm:text-xl font-medium" }
const _hoisted_7 = {
  key: 0,
  class: "py-2 text-red-600 text-medium sm:text-xl font-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createVNode(_component_router_link, {
          class: "px-3 sm:px-5 my-2 hover:border-b-2 border-red-600",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "px-3 sm:px-5 my-2 hover:border-b-2 border-red-600",
          to: "/bikes"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Bikes")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "px-3 sm:px-5 my-2 hover:border-b-2 border-red-600",
          to: { name: 'contact', hash: '#contact-us' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("Contact Us")
          ]),
          _: 1
        })
      ]),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "px-3 sm:px-5 my-2 hover:border-b-2 border-red-600",
              to: { name: 'admin', hash: '/admin' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("Management")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_view)
  ], 64))
}